function Footer() {
    return ( 
        <div className="footer-container">

<div className="footer center-align">
    <div className="container">
        <div>&copy; <script>document.write(new Date().getFullYear()); </script> PORG. Všechna práva vyhrazena.</div>
    </div>
</div>

        </div>
     );
}

export default Footer;